import { getRecords } from "../../../System/Api/OPEXAPI";
import {
    getActiveSystemFuelSurchargeRate,
    getEffectiveFuelSurchargeRate,
} from "../../../System/Global/fuelSurchargeUtils";

const generatePrices = async (collections, deliveries, miles, roundTrip, startCountry, endCountry, clientKey, startPostcode = false, endPostcode = false, clientOverride = null, effectiveDate = new Date()) => {

        // Get the rates and tariffs - use clientOverride when provided (e.g. from QuickQuote state) to avoid refetch mismatches
        const defaults = ( await getRecords(`SELECT defaultRates, setRoutes FROM partner_settings WHERE partnerKey = ?`, ["cb634e90-a476-11e9-9703-7916d03cce68PARTNER"]))[0]
        const client = (clientOverride && clientOverride.clientKey === clientKey) ? clientOverride : ( await getRecords(`SELECT * FROM clients WHERE clientKey = ?`, [clientKey]))[0]
        const vtypes = await getRecords(`SELECT * FROM vehicle_types WHERE vtKey != ? ORDER BY orderNo ASC`, ["296b00c6-feff-4b36-8e65-65044d74cc8c"])

        let fuelSurchargeRates = await getRecords(`SELECT * FROM finance_fuelsurcharge ORDER BY fs_from DESC`);
        let fuelSurchargeClientRates = [];
        try {
            fuelSurchargeClientRates = await getRecords(`SELECT * FROM finance_fuelsurcharge_client WHERE clientKey = ? ORDER BY fsc_from DESC`, [clientKey]);
        } catch (err) {
            fuelSurchargeClientRates = [];
        }
        const activeSystemFuelSurcharge = getActiveSystemFuelSurchargeRate(fuelSurchargeRates, effectiveDate || new Date());
        const effectiveFuelSurcharge = getEffectiveFuelSurchargeRate({
            client,
            clientKey,
            systemPercent: activeSystemFuelSurcharge.percent,
            customRates: fuelSurchargeClientRates,
            targetDate: effectiveDate || new Date(),
        });

        console.group("Fuel Surcharge Debug");
        console.log("client (full record):", client);
        console.log("clientKey used:", clientKey);
        console.log("clientOverride provided:", !!clientOverride);
        console.log("activeSystemFuelSurcharge:", activeSystemFuelSurcharge);
        console.log("effectiveFuelSurcharge:", effectiveFuelSurcharge);
        console.log("Fuel (final):", {
            systemPercent: activeSystemFuelSurcharge.percent,
            effectivePercent: effectiveFuelSurcharge.percent,
            source: effectiveFuelSurcharge.source,
            hasSystemRate: activeSystemFuelSurcharge.hasSystemRate,
        });
        console.groupEnd();

        const countries = await getRecords(`SELECT * FROM countries WHERE id > 0`)

        const ukDefaultRates =  JSON.parse(defaults.defaultRates);
        const systemSetRoutes = JSON.parse(defaults.setRoutes);
        const ukClientRates =   JSON.parse(client.pricing);
        const euClientRates =   JSON.parse(client.otherPricing);
        const clientSetRoutes = JSON.parse(client.setRoutes);

        let clientSetRouteRates = [];
        let systemSetRouteRates = [];
        let mileagePrices = [];

        
        const calculateMileagePrices = async (clientRates = [], defaultRates = []) => {

            console.log('calculateMileagePrices')
            console.log(clientRates)
            console.log(defaultRates)
                
                const dels = deliveries.length - 1;
                const cols = collections.length - 1;
                const prices = [];
            
                const getRateValue = (code, rateType) => {
                    if (clientRates && clientRates[`${code}${rateType}`]) {
                        return parseFloat(clientRates[`${code}${rateType}`]);
                    }
                    return parseFloat(defaultRates[`${code}${rateType}`]) || 0;
                };
            
                vtypes.forEach(v => {
                    let mileRateKey = '';
                    if (miles > 300) mileRateKey = 'Miles300';
                    else if (miles > 200) mileRateKey = 'Miles200';
                    else if (miles > 100) mileRateKey = 'Miles100';
                    else mileRateKey = 'Miles0';
            
                    const mileRate = getRateValue(v.code, mileRateKey);
                    const standingCharge = getRateValue(v.code, 'Stand');
                    const minimumCharge = getRateValue(v.code, 'Min');
                    const dropCharge = getRateValue(v.code, 'Drop');
                    const roundTripPercent = (clientRates && clientRates[`${v.code}Percent`]) || defaultRates[`${v.code}Percent`] || 1;
            
                    let totalCost = mileRate * miles + standingCharge;
                    totalCost += dropCharge * (dels + cols);
                    if (roundTrip) totalCost *= (1 + roundTripPercent / 100);
                    totalCost = Math.max(totalCost, minimumCharge);
                    totalCost = Math.ceil(totalCost).toFixed(0);
            
                    prices.push({
                        price: totalCost,
                        display: v.code,
                        ...v,
                    });
                });
            
                return prices;
        };

        const checkFixedRoutes = async (fixedRoutes, collection, delivery, roundTrip) => {

            console.log('checkFixedRoutes')
            console.log(fixedRoutes)
            console.log(collection)
            console.log(delivery)
            console.log(roundTrip)

            let prices = [];
        
            const formatPostCode = (postCode, country) => {
                return country !== "GB" ? postCode.replace(/\D/g, '').toUpperCase() : postCode.toUpperCase();
            };
        
            collection.postCode = formatPostCode(collection.postCode, startCountry);
            delivery.postCode = formatPostCode(delivery.postCode, endCountry);
        
            fixedRoutes.forEach(fr => {

                
                const normalizeCountry = (country) => country.toUpperCase() === "UK" ? "GB" : country.trim().toUpperCase();
        
                fr.colCountry = fr.colCountry ? normalizeCountry(fr.colCountry) : '';
                fr.delCountry = fr.delCountry ? normalizeCountry(fr.delCountry) : '';
        
                if (fr.colCountry === startCountry && fr.delCountry === endCountry && roundTrip === fr.roundTrip) {
                    const isMatch = (routePostCode, actualPostCode) => {
                        if (routePostCode.length === 1) {
                            return actualPostCode.startsWith(routePostCode) && !isNaN(actualPostCode[1]);
                        }
                        return actualPostCode.startsWith(routePostCode);
                    };
        
                    if (isMatch(fr.collection.toUpperCase(), collection.postCode.toUpperCase()) && isMatch(fr.delivery.toUpperCase(), delivery.postCode.toUpperCase())) {
                        
                        console.log('fr', fr)
                        
                        vtypes.forEach(v => {
                            let code = v.code[0].toUpperCase() + v.code.slice(1);
                            let price = parseFloat(fr[`price${code}`]) || 0;
        
                            prices.push({  
                                price,
                                display: v.code,
                                ...v,
                            });
                        });
                    }
                }
            });
        
            return prices;
        };
        
        
        
        if (endCountry === "NIE") { endCountry = "IE" }
        if (startCountry === "NIE") { startCountry = "IE" }

        if (collections.length === 1 && deliveries.length === 1) {

            if (collections[0].postCode && deliveries[0].postCode) {
                
                clientSetRouteRates = await checkFixedRoutes(clientSetRoutes, collections[0], deliveries[0], roundTrip)
                systemSetRouteRates = await checkFixedRoutes(systemSetRoutes, collections[0], deliveries[0], roundTrip)


            } else if (startPostcode && endPostcode) {

                

                if (clientSetRoutes) {

                    clientSetRouteRates = await checkFixedRoutes(clientSetRoutes, 
                    {postCode: startPostcode}, 
                    {postCode: endPostcode}, roundTrip
                    )
                }
                

                if (systemSetRoutes) {

                    systemSetRouteRates = await checkFixedRoutes(systemSetRoutes, 
                    {postCode: startPostcode}, 
                    {postCode: endPostcode}, roundTrip
                )
                }
                
            }
        }

        if (endCountry === 'GB' && startCountry === 'GB') {

            
            // generate uk prices
            mileagePrices = await calculateMileagePrices(ukClientRates, ukDefaultRates)
            

        } else {

                const findRatesForCountry = (countryCode, rateList) => {
                        const foundRate = rateList.find(item => item.code === countryCode);
                        return foundRate ? JSON.parse(foundRate.defaultRates) : {};
                };
                
                const euDefaultRatesFound = findRatesForCountry(endCountry, countries) || findRatesForCountry(startCountry, countries);
                const clientRateEntry = euClientRates.find(item => item.countryCode === endCountry || item.countryCode === startCountry);
                const euClientRatesFound = clientRateEntry ? clientRateEntry.pricing : {};

                mileagePrices = await calculateMileagePrices(euClientRatesFound, euDefaultRatesFound);
        }

        console.group("Set routes");
        console.log('client set routes', clientSetRouteRates)
        console.log('system set routes', systemSetRouteRates)
        console.groupEnd("-----")

        console.group("Mileage prices");
        console.log('Mileage price', mileagePrices)
        console.groupEnd("-----")
        

        return {
            clientSetRouteRates,
            systemSetRouteRates,
            mileagePrices,
            fuelSurcharge: {
                systemPercent: activeSystemFuelSurcharge.percent,
                effectivePercent: effectiveFuelSurcharge.percent,
                source: effectiveFuelSurcharge.source,
                hasSystemRate: activeSystemFuelSurcharge.hasSystemRate,
            },
        };

}

export default generatePrices;
